'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.DataRetriever', 'AVRO.Common.FileSave'];
module.exports = angular.module('AVRO.UserExclusions.ExclusionRules', dependencies).controller('UserExclusionRulesController', require('./controllers/UserExclusionRulesController')).directive('rmUserExclusionRules', require('./directives/UserExclusionRulesDirective')).factory('UserExclusionRulesService', require('./services/UserExclusionRulesService'));